import { render } from "./kycDocuments.vue?vue&type=template&id=4289c38e&scoped=true&lang=true"
import script from "./kycDocuments.vue?vue&type=script&lang=js"
export * from "./kycDocuments.vue?vue&type=script&lang=js"

import "./kycDocuments.vue?vue&type=style&index=0&id=4289c38e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4289c38e"]])

export default __exports__